import { Component, OnInit, AfterViewInit, ViewChildren, QueryList, ElementRef, ChangeDetectorRef } from "@angular/core";
import { Subject } from 'rxjs';
import { takeUntil, take } from 'rxjs/operators';
import { WorkforceGroup, JoiEvent, WFWorker } from 'src/app/store/events.era';
import { EditColumnsDialogComponent } from './edit-columns.dialog.component';
import { AddWorkforceToGroupDialogComponent } from './workforce.dialog.add-to-group.component';
import { UpsertGroupDialogComponent } from './workforce.dialog.upsert-group.component';
import { AddWorkforceToGroupByListDialogComponent } from './workforce.dialog.addToGroupByList.component';
import { ViewProfileDialogComponent } from './workforce.dialog.viewProfile.component';
import { EditRoleDialogComponent } from './workforce.dialog.edit-role.component';
import { ChangePermissionsDialogComponent, ChangePermissionsDialogData } from './workforce.dialog.changePermissions.component';
import { InviteDialogComponent } from './workforce.dialog.invite.component';
import { AddWorkforceToContactsDialogComponent, AddWorkforceToContactsData } from './workforce.dialog.addToContacts.component';
import { PAGE_NAME } from 'src/app/services/event.permissions.service';
import { accountsHeldReselector } from 'src/app/store/reselectors/accounts.reselector';
import { AccountIdListByEmail, ContactByAccountIdAndEmail } from 'src/app/store/contacts.era';
import { readOnlyReselector } from 'src/app/store/reselectors/permissions.reselector';
import { columnOrderTypes, columnTitles, workforceColumns } from 'src/app/store/settings.era';
import { ManageTaskComponent } from 'src/app/modules/manage/manage-task.component';
import { WorkerWithProfile } from 'globals/store/workforce.data';
import { ConfirmDeleteData, openConfirmDeleteGetResult } from 'src/app/components/dialog.confirmDelete.component';
import { nameJoiner } from '../../helpers/helpers';
import { Wrapper } from 'src/app/components/wrapper.component';
import { ReinviteWorkerData } from 'globals/store/workforce.data';
import { manageSessionPermissionReselector, manageSessionStates, ManageSessionStates } from "../../store/reselectors/sessions.reselector";
import { AccessType } from "globals/store/permissions.data";
import { Dictionary } from "@ngrx/entity";
import { AccountPublicInfo, JoiAccount } from "globals/store/accounts.data";
import { jsonCopyObject } from "globals/helpers/helpers";
import { MatMenuModule } from "@angular/material/menu";
import { SmallButtonComponent } from "src/app/components/buttons/small-button.component";
import { CommonModule } from "@angular/common";
import { LoaderPaneFragmentComponent } from "src/app/components/loader/loader-pane-fragment.component";
import { MobileMenuComponent } from "src/app/components/menu/mobile-menu.component";
import { JoiNavWrapper } from "src/app/components/wrappers/joi-nav-wrapper.component";
import { IconComponent } from "src/app/components/icon/icon.component";
import { SearchBarComponent } from "src/app/components/search-bar";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatSelectModule } from "@angular/material/select";
import { PhotoComponent } from "src/app/components/photo";
import { FormsModule } from "@angular/forms";
import { MessagePanelComponent } from "src/app/components/message-panel";
import { traceNames } from "src/app/services/performance.tracking.data";
import { MatButtonModule } from "@angular/material/button";
@Component({
    selector: 'workforce',
    templateUrl: "./workforce.main.html",
    styleUrls: ["workforce.main.scss", "../../page.scss"],
    standalone: true,
    imports: [MatMenuModule, MatButtonModule, SmallButtonComponent, MessagePanelComponent, CommonModule, LoaderPaneFragmentComponent, MobileMenuComponent, JoiNavWrapper, IconComponent, SearchBarComponent, MatCheckboxModule, MatSelectModule, PhotoComponent, FormsModule, ],
})
export class WorkforceMainComponent extends Wrapper<WorkforceMainComponent> implements OnInit, AfterViewInit {

  private $initView: Subject<boolean> = new Subject();
  pageNames = PAGE_NAME
  traceNames = traceNames
  search_input = '';
  defaultMode = true;
  displayWorkers = [];
  declined_workers = [];
  DEFAULT_CELL_WIDTH = 200
  MAX_CELL_WIDTH = 400
  CELL_PADDING = 40
  displayedColumns: string[] = workforceColumns.filter(c => c.selected).map(c => c.value)
  cellWidths = {}
  columnTitles: { [id: string]: string } = columnTitles.workforce
  specialRenderers: Set<string> = new Set(['user', 'groups', 'phone', 'email', 'permissions'])
  workforceGroupsById: { [id:string]: WorkforceGroup } = {}
  columnHeaderClasses = { phone: "header md", default: "header lg", groups: "header lg group" }
  selectedGroupIndex = -1;
  single_selected_name_for_menu = '';
  single_selected_uid_for_menu = '';
  selected_emails_for_menu = '';

  show_role = {};
  readOnly = true

  totalSelected = 0;
  sortDirections = {};
  currentSort = {};
  ownerSelected: boolean;
  message = '';
  keyword = '';
  loading = false;

  groupColumnWidth;
  filteredWorkers: WorkerWithProfile[] = []
  selectedGroup: any

  workers: WFWorker[] = []
  wf_groups: WorkforceGroup[] = []
  currentEvent: JoiEvent
  panel = 'all'
  svgs = {}

  canAddToContacts = true;
  availableAccountsForContacts: AccountPublicInfo[] = []
  @ViewChildren('cellEl') cellEl: QueryList<ElementRef>;
  accountId: string
  page_name = PAGE_NAME.workforce;
  tasks_page_name = PAGE_NAME.tasks;
  accountsHeld: AccountPublicInfo[]
  accountIdListByEmail: AccountIdListByEmail = {}
  contactByAccountIdAndEmail: ContactByAccountIdAndEmail = {}
  readState: keyof ManageSessionStates = manageSessionStates.ReadOnly
  account: Partial<JoiAccount>
  eventWidePermissions: Dictionary<AccessType[]> = {}


  async makeEventOwner(newOwner: WFWorker, fromEl) {
    // I'm leaving this and the one below (removeMultiple) because the helper function that is nested and called from the service is quite complex
    const currentOwner = this.currentEvent.event_owner
    console.log({ currentOwner })
    const data: ConfirmDeleteData = {
      rect: document.getElementsByClassName(fromEl)[0].getBoundingClientRect(),
      title: `Make ${ nameJoiner(newOwner) } the owner`,
      para: `${ nameJoiner(currentOwner) } will no longer be the event owner. This may take up to a minute to take effect`,
      delete_btn_text: 'CHANGE OWNER',
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    this.eventService.changeEventOwner(this.currentEvent, newOwner)
  }

  finishLoadingWorkforce() {
    this.filteredWorkers = this.selectedGroup ? this.displayWorkers.filter(w => this.selectedGroup.members.indexOf(w.email) > -1) : this.displayWorkers;
    this.filterWorkerList(this.keyword);
    this.totalSelected = 0;
    this.sortWorkerList(this.workforceService.workforceSortPreference.by, this.workforceService.workforceSortPreference.direction, true);
    this.loading = false;
  }

  constructor(private changeDetectorRef: ChangeDetectorRef) {
    super()
    this.loading = true
    this.uiService.changePageTitle("Workforce",true)
    this.selectProp(manageSessionPermissionReselector, null, 'readState')
    this.subProp(this.store.select('workforce', 'workforceGroupsById'), 'workforceGroupsById')
    this.subProp(this.store.select(readOnlyReselector), 'readOnly')
    this.subProp(this.store.select('contacts', 'accountIdListByEmail'), 'accountIdListByEmail')
    this.subProp(this.store.select('contacts', 'contactByAccountIdAndEmail'), 'contactByAccountIdAndEmail')
    this.subProp(this.store.select('accounts', 'accountId'), 'accountId')
    this.subProp(this.store.select('permissions', 'eventWidePermissions'), 'eventWidePermissions')
    this.subProp(this.store.select('accounts', 'account'), 'account')
    this.subProp(this.store.select(accountsHeldReselector), 'accountsHeld')
    this.subProp(this.store.select('events', 'event'), 'currentEvent')
    this.subCallback(this.store.select('workforce'), ({ wf_groups, workforce, declined_workers, loadingProfiles }) => {
      // console.log("GOT ME A CALLBACK", { wf_groups, workforce, declined_workers, loadingProfiles })
      this.declined_workers = declined_workers
      this.displayWorkers = jsonCopyObject(workforce)
      this.workers = jsonCopyObject(workforce)
      this.wf_groups = wf_groups
      // console.log({ wf_groups, workforce, declined_workers, loadingProfiles })
      this.finishLoadingWorkforce()

      if (!loadingProfiles) {
        this.loading = false
      }
    })
    this.subCallback(this.store.select('settings', 'user','workforce_columns'), workforce_columns => {
      if(!workforce_columns) return;
      this.displayedColumns = workforce_columns.filter(col => col.selected).map(col => col.value)
    })

    this.sortDirections = this.displayedColumns.map(col => {
      const obj = {};
      obj[col] = 'asc';
      return obj;
    }).reduce((acc, cur) => ({ ...acc, ...cur }))

  }

  ngOnInit() {
    this.cellWidths = this.getDefaultCellWidths()
    // console.log({ PSRO: this.permissionsService.readonly, pageNames: this.pageNames, readOnly: this.readOnly })
  }

  getDefaultCellWidths() {
    return Object.assign({}, ...this.displayedColumns.map((k, i) => ({ [k]: this.DEFAULT_CELL_WIDTH })))
  }


  adjustCellWidths() {
    const cellWidths = this.getDefaultCellWidths()
    this.cellEl.forEach(el => {
      let cellType = <string>Array.from(el.nativeElement.classList).find((c: string) => c.includes("Cell"))
        if (!cellType) {
          console.log("Couldn't find class xxxCell in el!")
          return
        }
        cellType = cellType.split("Cell")[0] // get name, like "groups", "email"
        const innerClass = "inner-" + cellType
        const els = el.nativeElement.getElementsByClassName(innerClass)
        let elWidth: number = <number>Array.from(els).reduce((acc, cur) => acc += cur['clientWidth'], 0) + this.CELL_PADDING
        elWidth = Math.min(elWidth, this.MAX_CELL_WIDTH)
        cellWidths[cellType] = elWidth > cellWidths[cellType] ? elWidth : cellWidths[cellType]
    })
    const that = this
      setTimeout(() => {
        if (!that.changeDetectorRef['destroyed']) {
          that.cellWidths = cellWidths
          that.changeDetectorRef.detectChanges()
        } else {
          // console.log("Change detector ref ALREADY DESTROYED! (this was a bug nobody saw)")
        }
      }, 10)
  }
  ngAfterViewInit() {
    this.$initView.next(true)
    this.adjustCellWidths()
    const cellWidths = this.getDefaultCellWidths()
    this.cellEl.changes.pipe(takeUntil(this.$initView)).subscribe(_ => this.adjustCellWidths()) // a little bit ugly of a solution, resubscribing after every view init, but it works
  }


  filterWorkerList(evt) {
    this.keyword = evt;
    const workers = [];
    this.filteredWorkers = this.selectedGroup ? this.displayWorkers.filter(w => this.selectedGroup.members.indexOf(w.email) > -1) : this.displayWorkers;
    this.filteredWorkers.forEach((w, i) => {
      workers[i] = this.displayedColumns.map(col => {
        if (col === 'user') {
          return w.firstName + w.lastName;
        } else if (col === 'groups') {
          return w.groups ? w.groups.join('') : '';
        } else {
          return w[col];
        }
      }).join('').toLowerCase();
    });
    this.filteredWorkers = this.filteredWorkers.filter((w, i) => workers[i].indexOf(this.keyword.toLowerCase()) > -1);
    // console.log(this.filteredWorkers, workers)
  }
  sortWorkerList(by, direction, init = false, event = null) {
    // console.log(by, direction, this.currentSort['by'])
    if (event) {
      event.stopPropagation()
    }
    let dir = direction;
    if (!this.currentSort['by'] || this.currentSort['by'] !== by || init) {
      this.workforceService.workforceSortPreference = { by, direction };
      this.currentSort = { by, direction };
    } else {
      dir = direction === 'asc' ? 'desc' : 'asc';
      this.workforceService.workforceSortPreference = { by, direction: dir };
      this.currentSort = { by, direction: dir };
    }
    this.sortDirections[by] = dir;
    this.filteredWorkers.sort((w1, w2) => {
      if (by === 'user') {
        return (w1.firstName + w1.lastName) > (w2.firstName + w2.lastName) ? (dir === 'asc' ? 1 : -1) : (dir === 'desc' ? 1 : -1);
      } else {
        const str1 = w1[by] ? w1[by] : '';
        const str2 = w2[by] ? w2[by] : '';
        return str1 > str2 ? (dir === 'asc' ? 1 : -1) : (dir === 'desc' ? 1 : -1);
      }
    });
    // console.log(this.sortDirections)
    // TODO: Save workforce here <== why would you want to save this state to firebase? It's just temporary sorting
  }
  toggleDefault(detailed) {
    this.defaultMode = detailed;
  }

  toggleAll(evt) {
    // console.log(evt);
    if (this.totalSelected === this.filteredWorkers.length) {
      this.filteredWorkers.forEach(w => w.selected = false);
      this.totalSelected = 0;
    } else {
      this.filteredWorkers.forEach(w => w.selected = true);
      this.totalSelected = this.filteredWorkers.length;
    }
    this.toggleSelect();
  }

  canAddToContactsChecks() {
    this.availableAccountsForContacts = this.accountsHeld.filter(({ id }) => !this.contactByAccountIdAndEmail[id] || this.filteredWorkers.filter(w => w.selected).some(w =>   !this.contactByAccountIdAndEmail[id][w.email]))
    this.canAddToContacts = this.availableAccountsForContacts.length !== 0
  }
  toggleSelect() {
    const selectedWorkers = this.filteredWorkers.filter(w => w.selected)
    this.totalSelected = selectedWorkers.length
    if (this.totalSelected === 1) {
      const worker = this.filteredWorkers.find(w => w.selected);
      this.single_selected_name_for_menu = worker ? worker.firstName : '';
      this.single_selected_uid_for_menu = worker ? worker.uid : '';
    } else {
      this.single_selected_name_for_menu = '';
      this.single_selected_uid_for_menu = '';
    }
    if (this.totalSelected > 0) {
      const emails = this.filteredWorkers.filter(w => w.selected).map(w => w.email);
      this.selected_emails_for_menu = emails.join(',');
    } else {
      this.selected_emails_for_menu = '';
    }
    this.ownerSelected = !!selectedWorkers.find(w => w.uid === this.currentEvent.created.uid)
    this.canAddToContactsChecks()

  }
  selectGroup(group, idx) {
    if (this.selectedGroupIndex === idx) {
      this.selectedGroupIndex = -1;
      this.selectedGroup = null;
    } else {
      this.selectedGroupIndex = idx;
      this.selectedGroup = group;
    }
    this.filteredWorkers = this.selectedGroup ? this.displayWorkers.filter(w => this.selectedGroup.members.includes(w.email)) : this.displayWorkers;
    this.totalSelected = this.filteredWorkers.reduce((acc, cur) => acc + (cur.selected ? 1 : 0), 0);
    this.filterWorkerList(this.keyword);
    this.sortWorkerList(this.workforceService.workforceSortPreference.by, this.workforceService.workforceSortPreference.direction, true);
  }

  editColumns() {

    const d = this.dialog.open(EditColumnsDialogComponent, { width: '480px', disableClose: true, data: columnOrderTypes.workforce } );
  }
  addToGroup() {
    const d = this.dialog.open(AddWorkforceToGroupDialogComponent, { width: '480px', disableClose: true, data: { workers: this.filteredWorkers, wf_groups: this.wf_groups } });
  }


  editGroup(group, idx) {
    const d = this.dialog.open(UpsertGroupDialogComponent, { width: '480px', disableClose: true, data: { is_new: false, group, idx } });
    d.afterClosed().pipe(take(1)).subscribe(result => {
      if (result && result.cmd === 'delete') {
        this.selectedGroupIndex = -1;
        this.selectedGroup = null;
      }
    });
  }
  addGroup() {
    const d = this.dialog.open(UpsertGroupDialogComponent, { width: '480px', disableClose: true, data: { is_new: true } });
  }

  addToGroupByList() {
    const workers = this.displayWorkers.filter(w => !w.groups.includes(this.selectedGroup.name));
    const d = this.dialog.open(AddWorkforceToGroupByListDialogComponent, { width: '480px', disableClose: true, data: {'workers': workers, 'selectedGroup': this.selectedGroup, 'selectedGroupIndex': this.selectedGroupIndex}});
  }

  async removeFromGroup(evt) {

    const data = {
      rect: evt.target.getBoundingClientRect(),
      title: 'Remove ' + this.totalSelected + ' selected ' + (this.totalSelected === 1 ? 'person' : 'people') + ' from ' + this.wf_groups[this.selectedGroupIndex].realName,
      delete_btn_text: 'REMOVE' ,
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return

    const workers = this.filteredWorkers.filter(w => w.selected);

    // delete workers from component
    const groupMemberSet = new Set(this.selectedGroup.members)
    workers.forEach(w => groupMemberSet.delete(w.email))
    this.selectedGroup.members = Array.from(groupMemberSet)

    // delete workers from firebase
    this.wf_groups[this.selectedGroupIndex].members = this.selectedGroup.members
    this.workforceService.upsertWorkforceGroups(this.wf_groups)
  }

  addWorkerToGroup(worker, idx) {
    this.workforceService.addMemberToGroup(worker.email, idx).then(ret => console.log(ret));
  }
  mailto(evt, recipients) {
    if(evt.stopPropagation) evt.stopPropagation()
    const url = 'mailto:' + recipients;
    // shifiting to always open target="_blank, per tony's recommendation"
    const win = window.open(url,'_blank');
    win.focus();
    setTimeout(function () {
      if (!evt.ctrlKey && win && win.document && !win.document.hasFocus()) {
        win.close();
      }
    }, 500)

  }
  viewProfile(evt, worker) {
    // console.log(evt)
    if (!evt.target.classList.contains('noProfile')) {
      this.dialog.open(ViewProfileDialogComponent, {
        width: '480px',
        data: {
          worker,
          profileProvided: true
         }
      });
    }
  }
  editRole(worker) {
    const d = this.dialog.open(EditRoleDialogComponent, { width: '480px', data: { worker } });
    d.afterClosed().pipe(take(1)).subscribe(result => {
      if (result === 'save') {
        this.workforceService.saveRole(worker);
      }
    });
  }
  
  async createTask(worker) {
    if (!worker) {
      const wf = this.filteredWorkers.filter(w => w.selected)
      if (wf.length) {
        worker = wf[0];
      } else {
        return;
      }
    }
    if (this.currentEvent.closed) return;
    this.changeDetectorRef.detach()
    await this.taskService.makeAndSaveAndOpenWorkerTask(worker, this.dialog, ManageTaskComponent)
    this.changeDetectorRef.reattach()
  }

  changePermissions(uid_or_email: string) {
    const workerWithProfile = this.filteredWorkers.find(w => w.uid === uid_or_email || w.email === uid_or_email)
    const currentPermissions = this.eventWidePermissions[uid_or_email]
    const data: ChangePermissionsDialogData = { uid_or_email: uid_or_email, isLogistics: this.readState === 'Logistics', currentPermissions, workerWithProfile }

    console.log({ uid_or_email, workerWithProfile, currentPermissions, data, eventWidePermissions: this.eventWidePermissions })
    this.dialog.open(ChangePermissionsDialogComponent, { width: '480px', autoFocus:false, disableClose: true, data })
  }

  async reinviteWorker(worker: WFWorker, fromEl) {
    const el = document.getElementsByClassName(fromEl)
    window['dots'] = el 
    const rect = el[0].getBoundingClientRect()
    const data: ConfirmDeleteData = {
      rect, 
      title: `Reinvite ${nameJoiner(worker)}`,
      para: `This will resend the invitation email to:\n${worker.email}`,
      delete_btn_text: 'SEND',
      dialog: this.dialog,
      green: true
    }
    const reinvite = await openConfirmDeleteGetResult(data)
    const reinviteData: ReinviteWorkerData = { workerEmail: worker.email, eventId: this.currentEvent.eventId }

    if (!reinvite) return
    this.workforceService.reinviteWorker(reinviteData)
  }


  async removeFromEvent(worker: WFWorker, fromEl) {
    // I'm leaving this and the one below (removeMultiple) because the helper function that is nested and called from the service is quite complex
    const data = {
      rect: document.getElementsByClassName(fromEl)[0].getBoundingClientRect(),
      title: 'Remove ' + (worker.uid === this.userService.uid ? 'yourself' : worker.firstName) + ' from event',
      delete_btn_text: 'REMOVE',
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return

    this.workforceService.removeFromEvent(worker, this.currentEvent)
    const you = await this.store.select('user', 'user').pipe(take(1)).toPromise()
    if (you.uid === worker.uid) this.router.navigate(['home'])

  }

  async removeMultipleFromEvent(evt) {
    const rect = evt.target.getBoundingClientRect();
    const title = 'Remove ' + this.totalSelected + ' selected ' + (this.totalSelected === 1 ? 'person' : 'people') + ' from event'
    const data = { rect, title, delete_btn_text: 'REMOVE', dialog: this.dialog }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    this.workforceService.removeManyFromEvent(this.filteredWorkers.filter(w => w.selected && w.uid !== this.currentEvent.created.uid))
  }

  inviteToWorkforce(event: Event, worker: WFWorker) {
    event.stopPropagation()
    this.dialog.open(InviteDialogComponent, { width: '480px', disableClose: true, data: { worker } })    
  }

  addToWorkforce() {
    this.dialog.open(InviteDialogComponent, { width: '480px', disableClose: true, data: null });
  }

  addWorkforceToContacts() {
    const workers = this.filteredWorkers.filter(w => w.selected).filter(w => w.uid !== this.userService.uid);
    // console.log({ workers, accountsHeld: this.accountsHeld, availableAccountIdsForContacts: this.availableAccountsForContacts })
    if (workers.length === 0 || this.accountsHeld.length === 0) throw new Error('No workforce selected or no available accounts');
    const msg = workers.length === 1
      ? (workers[0].firstName + ' ' + workers[0].lastName + '(' + workers[0].email + ') was added to contacts.')
      : workers.length + ' people were added to (or already exist in) contacts.';
    if (this.accountsHeld.length === 1) {
      this.contactsService.addMultipleToContacts(workers, this.availableAccountsForContacts.map(a => a.id)).then(() => this.message = msg);
    } else {
      const data: AddWorkforceToContactsData = {
        workers,
        availableAccounts: this.availableAccountsForContacts
      }
      const d = this.dialog.open(AddWorkforceToContactsDialogComponent, {
        width: '480px',
        disableClose: true,
        data
      })
      d.afterClosed().pipe(take(1)).subscribe(result => {
        if (result === 'success') {
          this.message = msg;
          this.canAddToContactsChecks()
        }
      });
    }
  }


}
